import CryptoJS from "crypto-js";
import { AesEncryptionIV, AesEncryptionKey, EMAIL_REGEX } from "Services/constants";
import { AdminVM } from "Components/searchbox/adminTab/useAdminTab";
import { RetrieveBookingResponse } from "Shared/models/RetrieveBookingResponse";

export const createAdminPostBody = (vm: AdminVM, token: string, culture: string): FormData => {
	const body = new FormData();

	const key = CryptoJS.enc.Utf8.parse(AesEncryptionKey);
	const iv = CryptoJS.enc.Utf8.parse(AesEncryptionIV);

	const pnr = vm.pnr.trim();
	const nameOrEmail = vm.nameOrEmail.trim();

	const aesPnr = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(pnr), key, {
		keySize: 128 / 8,
		iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7,
	});

	body.append("booking", btoa(aesPnr.toString()));

	const aesIdentifier = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(nameOrEmail), key, {
		keySize: 128 / 8,
		iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7,
	});

	body.append(EMAIL_REGEX.test(nameOrEmail) ? "email" : "lastName", btoa(aesIdentifier.toString()));
	body.append("culture", culture);
	body.append("gRecaptchaResponse", token);

	return body;
};

export interface ServerResponseCallbacks {
	culture: string;
	loader: { stopLoader: () => void; destroy: () => void };
	nameOrEmail: string;
	pnr: string;
	renderedCaptchaId: number;
	setIsAmericanAirlinesErrorVisible: (v: boolean) => void;
	setIsBookingErrorVisible: (v: boolean) => void;
	setIsFareLockErrorVisible: (v: boolean) => void;
	setIsTooManyJourneysErrorVisible: (v: boolean) => void;
	setIsUnauthorizedErrorVisible: (v: boolean) => void;
}

export const handleAdminServerResponse = async (
	response: Response,
	cb: ServerResponseCallbacks
): Promise<void> => {
	const result = await response.text();
	const parsedResult = JSON.parse(atob(result)) as RetrieveBookingResponse;

	const resetCaptchaAndLoader = () => {
		cb.loader.stopLoader();
		grecaptcha.reset(cb.renderedCaptchaId);
	};

	switch (parsedResult.code) {
		case 0: {
			const queryCulture = `culture=${cb.culture}`;
			const queryPnr = `rl=${cb.pnr}`;
			const queryUser = EMAIL_REGEX.test(cb.nameOrEmail) ? `em=${cb.nameOrEmail}` : `ln=${cb.nameOrEmail}`;
			location.href = `${window.JetSmart.Settings.BookingUrl}/Booking/Retrieve?${queryPnr}&${queryUser}&${queryCulture}`;
			break;
		}
		case 2:
		case 3:
		case 8:
			cb.setIsFareLockErrorVisible(true);
			resetCaptchaAndLoader();
			break;
		case 4:
			break;
		case 5:
			cb.setIsUnauthorizedErrorVisible(true);
			resetCaptchaAndLoader();
			break;
		case 6:
			cb.setIsTooManyJourneysErrorVisible(true);
			resetCaptchaAndLoader();
			break;
		case 7:
			cb.setIsAmericanAirlinesErrorVisible(true);
			resetCaptchaAndLoader();
			break;
		default:
			cb.setIsBookingErrorVisible(true);
			resetCaptchaAndLoader();
			break;
	}
};
